<template>
  <div>
    <div class="row">
      <div class="col-10">
        <OptimiserDailyChartWidget :filter="filter" title="Daily Optimiser Sheets" subTitle="Completed optimiser sheets broken down by daily stats" :gridHeight="400" />
      </div>
      <div class="col-2">
        <AnalyticsWidget title="Detailed Reports" subTitle="Click to access the detailed reports" :gridHeight="400">
          <div class="p-2">
            <AnalyticsReportLink href="/analytics/reports/production/optimiser#tab-stock-alloc">Stock Allocations Report</AnalyticsReportLink>
            <AnalyticsReportLink href="/analytics/reports/production/optimiser#tab-sheets-completed">Completed Sheets Report</AnalyticsReportLink>
          </div>
        </AnalyticsWidget>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <DashboardTabbedContentBox :gridHeight="640" large>
          <template v-slot:tablist>
            <Tab :first="true" tabid="tab-sheets-active">
              <i class="tabbedbox-tab-icon fas fa-layer-group"></i>
              <div class="tabbedbox-tab-info">
                <div class="tabbedbox-tab-title">Active Sheets</div>
                <div class="tabbedbox-tab-subtitle">Optimiser Sheet Chart</div>
              </div>
            </Tab>
            <Tab tabid="tab-sheets-completed">
              <i class="tabbedbox-tab-icon fas fa-tools"></i>
              <div class="tabbedbox-tab-info">
                <div class="tabbedbox-tab-title">Completed Sheets</div>
                <div class="tabbedbox-tab-subtitle">Optimiser Sheet Chart</div>
              </div>
            </Tab>
          </template>
          <template v-slot:tabcontent>
            <TabPage :first="true" tabid="tab-sheets-active" class="tabpage-padding-2">
              <OptimiserSheetChartWidget
                :type="OptimiserSheetChartTypes.activeSheets"
                :filter="filter"
                :gridHeight="500"
                :embedded="true"
                :showList="true"
              />
            </TabPage>
            <TabPage tabid="tab-sheets-completed" class="tabpage-padding-2">
              <OptimiserSheetChartWidget
                :type="OptimiserSheetChartTypes.completedSheets"
                :filter="filter"
                :gridHeight="500"
                :embedded="true"
                :showList="true"
                :dateRangeType="ChartDateRangeTypes.custom"
                :startDate="appliedOptimiserSheetFilter.startDate"
                :endDate="appliedOptimiserSheetFilter.endDate"
                :showDateFilter="true"
                @updateEditingStartDate="editingOptimiserSheetFilter.startDate = $event"
                @updateEditingEndDate="editingOptimiserSheetFilter.endDate = $event"
                @dateApplied="applyOptimiserSheetFilter"
                @dateReset="resetOptimiserSheetFilter"
              />
            </TabPage>
          </template>
        </DashboardTabbedContentBox>
      </div>
    </div>

  </div>
</template>


<script>
import _ from 'lodash'
import moment from 'moment'

import DashboardTitle from '@/components/dashboard/dashboardTitle'
import DashboardContentBox from '@/components/dashboard/dashboardContentBox'
import DashboardTabbedContentBox from '@/components/dashboard/dashboardTabbedContentBox'
import AnalyticsDashboardHeader from '@/modules/intelligence/components/analyticsDashboardHeader'
import AnalyticsWidget from '@/modules/intelligence/components/analyticsWidget'
import AnalyticsReportLink from '@/modules/intelligence/components/analyticsReportLink'
import AnalyticsDashboardValue from '@/modules/intelligence/components/analyticsDashboardValue'

import OptimiserDailyChartWidget from '@/modules/intelligence/dashboardWidgets/optimiserDailyChartWidget'
import OptimiserSheetChartWidget from '@/modules/intelligence/dashboardWidgets/optimiserSheetChartWidget'

import ReportFilterPopover from '@/components/reporting/reportFilterPopover'
import ReportDateRangeSelect from '@/components/reporting/reportDateRangeSelect'

import { ChartDateRangeTypes } from '@/modules/intelligence/types'

export default {
  name: 'AnalyticsOptimiserDashboard',
  components: {
    DashboardTitle,
    DashboardContentBox,
    DashboardTabbedContentBox,
    AnalyticsDashboardHeader,
    AnalyticsWidget,
    AnalyticsReportLink,
    AnalyticsDashboardValue,
    OptimiserDailyChartWidget,
    OptimiserSheetChartWidget,
    ReportFilterPopover,
    ReportDateRangeSelect
  },
  props: {
    filter: Object
  },
  data() {
    return {
      displaySheetChartFilter: false,

      defaultOptimiserSheetFilter: {    
        startDate: moment().local().startOf('month').toDate().toISOString(),
        endDate: moment().local().endOf('month').toDate().toISOString()
      },
      editingOptimiserSheetFilter: {},
      appliedOptimiserSheetFilter: {},      
    }
  },
  created() {
    this.ChartDateRangeTypes = ChartDateRangeTypes
    this.OptimiserSheetChartTypes = OptimiserSheetChartWidget.OptimiserSheetChartTypes
  },
  mounted() {
    this.editingOptimiserSheetFilter = _.clone(this.defaultOptimiserSheetFilter)
    this.appliedOptimiserSheetFilter = _.clone(this.defaultOptimiserSheetFilter)    
  },
  beforeDestroy() {
    
  },
  methods: {
    applyOptimiserSheetFilter() {
      this.appliedOptimiserSheetFilter = _.clone(this.editingOptimiserSheetFilter)
    },
    resetOptimiserSheetFilter() {
      this.editingOptimiserSheetFilter = _.clone(this.defaultOptimiserSheetFilter)
      this.appliedOptimiserSheetFilter = _.clone(this.defaultOptimiserSheetFilter)
    }
  }
  
}
</script>